import L from 'leaflet';

export function transformLayerToJson(layer) {
    const json = layer.toGeoJSON();
    if (layer instanceof L.Circle) {
        json.properties.radius = layer.getRadius();
    }
    return json;
}

function isCircleJson(geojson) {
    return geojson.geometry.type === "Point" && !!(geojson.properties && geojson.properties.radius);
}

// Radius (m) of the search area when it is a single circle, else null.
export function searchCircleRadius(geoms) {
    const features = Object.values(geoms || {});
    if (features.length !== 1 || !isCircleJson(features[0])) return null;
    return Math.round(features[0].properties.radius);
}

// The radius input can drive the search area only when it is empty or a single circle.
export function isRadiusEditable(geoms) {
    const count = Object.keys(geoms || {}).length;
    return count === 0 || searchCircleRadius(geoms) !== null;
}
